import { ENTRY_DATA_SECTION_KEYS as SECTION_KEYS } from "@frontend/common";

const BASE_ARTICLE_SECTION_CODE = {
  C000: SECTION_KEYS.clinicalTrial,
  C001: SECTION_KEYS.clinicalTrialStatus,
  C003: "Clinical Trials",
  C004: SECTION_KEYS.conferenceSchedule,
  C005: SECTION_KEYS.clinicalTrial,
  C006: SECTION_KEYS.deals,
  C007: "Clinical Trials",
  C008: SECTION_KEYS.publicationJournal,
  C009: "Clinical Trials",
  C010: "Clinical Trials",
  C011: "Clinical Trials",
  C012: "Clinical Trials",
  C013: SECTION_KEYS.regulatory,
  C201: SECTION_KEYS.regulatoryLabel,
  C202: SECTION_KEYS.regulatoryLabel,
  C014: "Clinical Trials",
  C015: "Clinical Trials",
  C016: SECTION_KEYS.expeditedProgram,
  C017: "Clinical Trials",
  C018: "Clinical Trials",
  C019: "Clinical Trials",
  C020: "Clinical Trials",
  C021: SECTION_KEYS.ventureCapital,
  C022: "Clinical Trials",
  C023: "Clinical Trials",
  C024: "Clinical Trials",
  C025: "Clinical Trials",
  C101: SECTION_KEYS.companyWebsiteVariousPages,
  C801: SECTION_KEYS.dealFiling,
  C802: SECTION_KEYS.fundingFiling,
  P001: SECTION_KEYS.publication,
  P002: SECTION_KEYS.publication,
  P004: SECTION_KEYS.publication,
  P005: SECTION_KEYS.publication,
  P006: SECTION_KEYS.publication,
  P007: SECTION_KEYS.publication,
  P008: SECTION_KEYS.publication,
  P009: SECTION_KEYS.publication,
  P010: SECTION_KEYS.publication,
  P011: SECTION_KEYS.publication,
  P012: SECTION_KEYS.publication,
  P013: SECTION_KEYS.publication,
  P014: SECTION_KEYS.publication,
  P999: SECTION_KEYS.publication,
  ctg: SECTION_KEYS.ctg,
  regulatoryLabel: SECTION_KEYS.regulatoryLabel,
} as const;

export const ARTICLE_SECTION_CODE: Record<string, string> = new Proxy(
  BASE_ARTICLE_SECTION_CODE as Record<string, string>,
  {
    get: (target, prop: string) =>
      prop.startsWith("DERA") ? SECTION_KEYS.ctg : Reflect.get(target, prop),
  },
);
